import { createSlice } from '@reduxjs/toolkit'
import { actions as dashboardActionsF } from './dashboard'
import { actions as dashboardTargetsActionsF } from './dashboardTargets'
import { actions as localActionsF } from './local'

const reducer = createSlice({
  name: 'app',
  initialState: {
    loaded: false,
    currentUser: {},
  },
  reducers: {
    set: (s, a) => a.payload,
    upsert: (s, a) => ({ ...s, ...a.payload })
  },
}).reducer

const actions = (dis, store, restClient) => {
  const localActions = localActionsF(dis, store, restClient)
  const dashboardActions = dashboardActionsF(dis, store, restClient)
  const dashboardTargetsActions = dashboardTargetsActionsF(dis, store, restClient)

  function load(dashboardId) {
    dis({ type: 'app/upsert', payload: { dashboardId } })

    restClient.get(`/api/user/dashboards/${dashboardId}`)
      .then(({ data }) => {
        dis({ type: 'app/upsert', payload: { loaded: true } })
        dashboardActions.set(data)
      })
      .catch((err) => {
        console.error('Error loading dashboard:', err)
        dis({ type: 'app/upsert', payload: { loaded: false } })
        dis({ type: 'local/upsert', payload: { alert: {
          severity: 'error',
          message: "Something went wrong and the dashboard couldn't be loaded."
        } } })
      })

    return reloadTargets()
  }

  function loadMe() {
    restClient.get('/api/users/me')
    .then(({ data }) => {
      dis({ type: 'app/upsert', payload: { currentUser: data } })
    })
  }

  function reloadTargets() {
    const dashboardId = store.getState().app.dashboardId
    if (!dashboardId) return

    return restClient.get(`/api/user/dashboards/${dashboardId}/dashboard_targets`, {
      params: {
        page: Math.max(1, store.getState().local.currentPage)
      }
    })
      .then(({ data }) => {
        localActions.upsert(data.pagination)
        dashboardTargetsActions.setAll(data.dashboardTargets)
      })
      .catch((err) => {
        console.error('Error reloading targets:', err)
        dis({ type: 'app/upsert', payload: { loaded: false } })
        dis({ type: 'local/upsert', payload: { alert: {
          severity: 'error',
          message: "Something went wrong and the dashboard couldn't be reloaded."
        } } })
      })
  }

  function answerQuestion({ dashboardTargetId, questionId, answer }) {
    return restClient.post(`/api/user/dashboard_targets/${dashboardTargetId}/answer_question`, { questionId, answer })
      .then(({ data }) => dashboardTargetsActions.upsert(data.id, data))
      .catch(() => {
        dis({ type: 'local/upsert', payload: { alert: {
          severity: 'error',
          message: "Something went wrong and the answer couldn't be saved."
        } } })
      })
  }

  return {
    load,
    loadMe,
    reloadTargets,
    answerQuestion
  }
}

export { reducer, actions }
export default { reducer, actions }
